export const focusOnEndOfInput = (
  element: HTMLInputElement | HTMLTextAreaElement,
) => {
  element.focus();
  element.setSelectionRange(element.value.length, element.value.length);
};

export const focusOnEndOfEditableContent = (element: HTMLElement) => {
  if (!element) {
    return;
  }
  element.focus();
  const selection = window.getSelection();

  if (!selection) {
    return;
  }

  const range = document.createRange();
  range.selectNodeContents(element);
  range.collapse(false);
  selection.removeAllRanges();
  selection.addRange(range);
};
